export default "__VITE_ASSET__DoZxrcLB__"